/**
 * Return the SVG path data for a right rounded rectangle.
 *
 * @param {number} x The x position of the top-left corner of the rectangle.
 * @param {number} y The y position of the top-left corner of the rectangle.
 * @param {number} width The width of the rectangle.
 * @param {number} height The height of the rectangle.
 * @param {number} radius The radius of the rounded corner on the right side.
 * @return {string} The SVG path data for the right rounded rectangle.
 */
export function rightRoundedRect(x, y, width, height, radius) {
  return "M" + x + "," + y
       + "h" + (width - radius)
       + "a" + radius + "," + radius + " 0 0 1 " + radius + "," + radius
       + "v" + (height - 2 * radius)
       + "a" + radius + "," + radius + " 0 0 1 " + -radius + "," + radius
       + "h" + (radius - width)
       + "z";
}

/**
 * Return the SVG path data for a top rounded rectangle.
 *
 * @param {number} x - The x position of the top-left corner of the rectangle.
 * @param {number} y - The y position of the top-left corner of the rectangle.
 * @param {number} width - The width of the rectangle.
 * @param {number} height - The height of the rectangle.
 * @param {number} radius - The radius of the rounded corner on the top side.
 * @returns {string} - The SVG path data for the top rounded rectangle.
 */
export function topRoundedRect(x, y, width, height, radius) {
  return "M" + (x + radius) + "," + y
       + "h" + (width - 2 * radius)
       + "a" + radius + "," + radius + " 0 0 1 " + radius + "," + radius
       + "v" + (height - radius)
       + "h" + (-width)
       + "v" + (-height + radius)
       + "a" + radius + "," + radius + " 0 0 1 " + radius + "," + -radius
       + "z";
}